import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 10
    },
    title: {
        marginBottom: theme.spacing(2),
		textAlign: 'center',
    },
    tab:{
        marginBottom: theme.spacing(2)
    },
    chart: {
        marginBottom: 10,
        //paddingLeft: 145
    },
    table: {
        '& .MuiTableCell-root': {
            fontSize: 10,
            padding: 0,
            borderColor: 'black',
            border: '1px solid'
        },
        '& .MuiTableCell-head': {
            backgroundColor: '#BEE1FC',
            '&:nth-of-type(odd)': {
                backgroundColor: '#DDF0FF',
            },
            '&:nth-of-type(1)': {
                backgroundColor: 'white',
                border: 'none',
            },
        },
    },
    tableGeneralBody: {
        '& .MuiTableCell-root': {
            backgroundColor: '#FFC5A1',
            '&:nth-of-type(odd)': {
                backgroundColor: '#FCD6BE',
            },
            '&:nth-of-type(1)': {
                width: 200,
            },
        },
    },
}));

export default useStyles;
